export default __webpack_public_path__ + "static/media/Blind Faith.59ab4ea3.png";